export default __webpack_public_path__ + "static/media/icon_add.6ae82f43.svg";